import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const CreateCompanyModal = ({ show, onHide, onCreated, pendingId, trial = false, trialDays = 14 }) => {
    const [label, setLabel] = useState('');
    const [shareContacts, setShareContacts] = useState(false);
    const [shareLocations, setShareLocations] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!label.trim()) {
            setError('Bitte gib einen Firmennamen ein.');
            return;
        }

        setLoading(true);
        try {
            const endpoint = trial
                ? '/index.php/settings/companies/createTrialCompany'
                : '/index.php/settings/companies/createCompany';
            const payload = {
                label: label.trim(),
                share_contacts: shareContacts,
                share_locations: shareLocations,
            };
            if (!trial) {
                payload.pending_id = pendingId || 0;
            }
            const res = await fetch(endpoint, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });

            const data = await res.json();

            if (!data.success) {
                setError(data.message || 'Fehler beim Erstellen.');
                return;
            }

            setLabel('');
            setShareContacts(false);
            setShareLocations(false);
            onCreated(data.user_sid || null);
        } catch (err) {
            setError('Netzwerkfehler. Bitte versuche es erneut.');
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setLabel('');
        setShareContacts(false);
        setShareLocations(false);
        setError('');
        onHide();
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Form onSubmit={handleSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title style={{ fontSize: '1.1rem', fontWeight: 600 }}>
                        {trial ? `Firma ${trialDays} Tage kostenlos testen` : 'Neue Firma erstellen'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {error && (
                        <div className="alert alert-danger py-2" style={{ fontSize: '0.875rem' }}>
                            {error}
                        </div>
                    )}

                    {trial && (
                        <div className="alert py-2" style={{
                            fontSize: '0.8125rem',
                            background: 'var(--bg-secondary, #f5f7f9)',
                            border: '1px solid var(--border-light, #e2e8f0)',
                            borderRadius: '8px',
                            color: 'var(--text-secondary, #64748b)',
                            lineHeight: 1.5,
                        }}>
                            Du testest eine zusätzliche Firma {trialDays} Tage kostenlos – ohne
                            Zahlungsdaten. Danach kannst du sie kostenpflichtig übernehmen; sonst
                            bleiben die Daten schreibgeschützt erhalten. Der Testzeitraum ist einmal
                            pro Account möglich.
                        </div>
                    )}

                    <Form.Group className="mb-3">
                        <Form.Label style={{ fontWeight: 500, fontSize: '0.875rem' }}>
                            Firmenname
                        </Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="z.B. Thomas Hochzeiten GbR"
                            value={label}
                            onChange={(e) => setLabel(e.target.value)}
                            autoFocus
                            style={{
                                borderRadius: '8px',
                                border: '1px solid var(--border-medium, #cbd5e1)',
                                padding: '0.5rem 0.75rem',
                            }}
                        />
                    </Form.Group>

                    <div
                        style={{
                            borderTop: '1px solid var(--border-light, #e2e8f0)',
                            paddingTop: '1rem',
                            marginTop: '0.5rem',
                        }}
                    >
                        <p
                            style={{
                                fontSize: '0.8125rem',
                                color: 'var(--text-secondary, #64748b)',
                                marginBottom: '0.75rem',
                            }}
                        >
                            Optional: Daten mit dem Hauptaccount teilen
                        </p>
                        <Form.Check
                            type="checkbox"
                            id="share-contacts"
                            label="Kontakte teilen"
                            checked={shareContacts}
                            onChange={(e) => setShareContacts(e.target.checked)}
                            style={{ fontSize: '0.875rem', marginBottom: '0.5rem' }}
                        />
                        <Form.Check
                            type="checkbox"
                            id="share-locations"
                            label="Locations teilen"
                            checked={shareLocations}
                            onChange={(e) => setShareLocations(e.target.checked)}
                            style={{ fontSize: '0.875rem' }}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer style={{ borderTop: '1px solid var(--border-light, #e2e8f0)' }}>
                    <Button
                        variant="outline-secondary"
                        onClick={handleClose}
                        style={{ borderRadius: '8px', fontSize: '0.875rem' }}
                    >
                        Abbrechen
                    </Button>
                    <Button
                        type="submit"
                        variant="primary"
                        disabled={loading}
                        style={{ borderRadius: '8px', fontSize: '0.875rem' }}
                    >
                        {loading ? (trial ? 'Starte...' : 'Erstelle...') : (trial ? 'Testfirma starten' : 'Firma erstellen')}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default CreateCompanyModal;
